<template>
  <div class="row" v-if="can_access('user','view')">
    <h1>Users</h1><a v-b-toggle="'collapse-1'" variant="info"><i class="fa fa-info"></i></a>
    <div class="col-sm-12 p-0 mb-2">
      <b-collapse id="collapse-1">
        <b-card>
          <p><b>Super User</b> - Can perform all the tasks in our platform.</p>
          <p><b>Trader</b> - Can Add, Edit, View Deals &amp; Clients But cannot approve Client/Deals, Can view FX Rate, Client Report, Securities</p>
          <p><b>Settlements Team</b> - Can Add, Edit, View Deals<!-- , Clients --> &amp; Securities and also Approve <!-- Clients and  -->Deals.</p>
          <p><b>Front Office Team</b> - Can Add, Edit, View, Approve Clients Only</p>
          <p><b>Compliance Team</b> - Can View Deals, Client Report, Securities, FX Rates, Market Value and Can Add, Edit, View, Approve Clients</p>
        </b-card>
      </b-collapse>
    </div>
    <div class="col-sm-12" v-if="can_access('user','modify')">
      <b-button class="btn-info pull-right" @click="showAddUserForm=showAddUserForm?false:true" title="Add User"><i :class="showAddUserForm?'fa fa-minus':'fa fa-plus'"></i></b-button>
    </div>
    <div class="col-sm-12 p-0" v-if="showAddUserForm && can_access('user','modify')">
      <AddUserForm @forceRerender="userFormReRender"/>
    </div>
    <div class="col-sm-12 p-0 mb-2">
      <select name="type" class="form-control col-sm-2 pull-right" v-model="status">
        <option value="2">all</option>
        <option selected value="1">active</option>
        <option value="0">inactive</option>
      </select>
    </div>
    <TableView :col="columns" :getData="getData" v-if="showUserList && can_access('user','view')"/>
  </div>
</template>

<script>
import Widget from '@/components/Widget/Widget';
import common from '@/assets/js/common.js';
import AddUserForm from '@/components/Accounts/AddUserForm';
import TableView from '@/components/Common/DataTable/Table';

export default {
  name: 'UsersPage',
  components: { Widget, TableView, AddUserForm },
  mixins: [common],
  data() {
    return {
      showAddUserForm: false,
      showUserList: true,
      errorMessage: null,
      status: 1,
      columns: (() => {
        const cols = [
          { title: 'Firstname', field: 'firstname', thComp: 'FilterTh', tdStyle: { fontStyle: 'italic' } },
          { title: 'Lastname', field: 'lastname', thComp: 'FilterTh', thStyle: { fontWeight: 'normal' } },
          { title: 'Email', field: 'email', thComp: 'FilterTh', tdComp: 'Email'},
          { title: 'Phone', field: 'phone_no', thComp: 'FilterTh'},
          { title: 'User Group', field: 'group_name', thComp: 'FilterTh'},
          { title: 'Create time', field: 'created_at', sortable: true, colClass: 'w-240', tdComp: 'CreatetimeTd' },
          { title: 'Operation', tdComp: 'UserOpt', visible: 'true', tdStyle:{'text-align':'center'}, thStyle:{'text-align':'center'} }
        ]
        const groupsDef = {
          Normal: [],
          Sortable: [],
          Extra: ['Operation']
        }
        return cols.map(col => {
          Object.keys(groupsDef).forEach(groupName => {
            if (groupsDef[groupName].includes(col.title)) {
              col.group = groupName
            }
          })
          return col
        })
      })(),
    };
  },
  watch: {
    status: function(value){
      this.showUserList = false;
      this.$nextTick(function(){
        this.showUserList = true;
      });
    }
  },
  methods: {
    userFormReRender(response) {
      if(response.code==0){
        this.showAddUserForm = false;
        this.$nextTick(function(){
          this.showAddUserForm = true;
          this.$toasted.success("Successfully Added",{duration:1000});
        });
      }
    },
    async getData(query, filter) {
      const { limit = 10, offset = 0, sort = '', order = '' } = JSON.parse(JSON.stringify(query));

      this.columns.forEach(col => {
        if (query[col.field]) {
          filter[col.field] = query[col.field];
        }else if(typeof filter[col.field] != 'undefined'){
          delete filter[col.field];
        }
      });

      let uri = 'user_list?limit='+limit+'&offset='+offset+'&sort='+sort+'&order='+order+'&filter='+JSON.stringify(filter)+'&status='+this.status;
      return await this.call_axios(uri);
    }
  },
  created() {
    
  },
};
</script>